export default {
  methods: {
    toggleSettings () {
      this.$dispatch('toggleSettings')
    },

    approve () {
      this.$dispatch('agree')
    },

    saveSettings () {
      this.$dispatch('saveSettings')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/kokuapp/cookie-shared.js